import {MigratedGamingHistoryRecordRawData} from "../../gaming-history.service.interfce";
import {IHistoryRecordAmountViewModel, IHistoryRecordIdViewModel, IHistoryRecordViewModel} from "./history-record-view-model.interface";
import {CyClass} from "../../../../../common/cy-classes";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

export class MigratedGamingHistoryRecordModel implements IHistoryRecordViewModel {
    constructor(protected readonly services: IServiceFactoryExtended,
        protected readonly recordData: MigratedGamingHistoryRecordRawData) {

    }

    get date(): string {
        //return this.recordData.TimeSincePlay.toString() // this.services.time.formatHistoryRecordDateTime(this.recordData.TimeSincePlay, false);
        return this.services.time.formatHistoryRecordDateTime(this.recordData.Date,  false);
    }

    get ids(): IHistoryRecordIdViewModel[] {
        return [
            {
                text: this.recordData.GameId,
                cyClass: CyClass('cy-migrated-gaming-history-round-id')
            }
        ];
    }

    
    get bigWinMessage(): string | null {
        return null;
    }

    private _getRealMoneyAmounts(): IHistoryRecordAmountViewModel[] {
        return [
            {
                description: this.translation.translate('GAMING_HISTORY_BET'),
                value: this._formatValue(this.recordData.BetAmount),
                cyClass: CyClass('cy-gaming-history-bet-value')
            },
            {
                description: this.translation.translate('GAMING_HISTORY_WINNINGS'),
                value: this._formatValue(this.recordData.ProfitAmount),
                cyClass: CyClass('cy-gaming-history-winning-value')
            },
            {
                description: this.translation.translate('GAMING_HISTORY_BANKROLL'),
                value: this._formatValue(this.recordData.AvailableMoneyPerOffering),
                cyClass: CyClass('cy-gaming-history-bankroll-value')
            }
        ];
    }

    get amounts(): IHistoryRecordAmountViewModel[] {
        return this._getRealMoneyAmounts();
    }
    
    get freePlayMessage(): string | null {
        return null;
    }

    get detailsHistoryNotAllowedOnCurrentPlatformMessage(): string | null {
        return null;
    }

    get gameName(): string {
        return this.recordData.GameName;
    }

    get gameImage(): string {
        return "";
    }

    get getGameImagePlaceHolderUrl(): string {
        if (this.services.theme.shouldUseSquareIcons) {
            return this.services.theme.currentTheme.images.gameIconPlaceHolderSq.toString();
        }
        return this.services.theme.currentTheme.images.gameIconPlaceHolder.toString();
    }

    get supportsDetailHistory(): boolean {
        return false;
    }

    async openDetailHistory(): Promise<void> {
        
    }

    private _formatValue(value: number): string {
        return this.services.currency.formatMoney(value);
    }

    private get translation() {
        return this.services.translation;
    }
}